module.exports = __webpack_public_path__ + "img/block01.95c567d6.webp";